module.exports = __webpack_public_path__ + "media/images/maybe_smiley-646011e325722531b34ababdf39cab66.svg";